module.exports = __webpack_public_path__ + "res/roboto-v15-latin-italic.woff";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/googlefonts/roboto-v15-latin-italic.woff
// module id = 105
// module chunks = 1